import React from 'react';

import { Web } from '@mui/icons-material';
import { Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import getEdgeReportingMenu from './getEdgeReportingMenu';
import { SubHeader, Footer } from '../../components';
import EdgeMenuItem from '../../components/EdgeMenuItem';

import './styles.scoped.css';

const EdgeReporting = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { menuItems, subHeader } = getEdgeReportingMenu(t);
  const { user } = useSelector(state => state.admin);

  const onPress = item => {
    navigate(item.to);
  };

  const getsReport = id => {
    const myEnv = { ...process.env };
    const edgeAppAccessItems = user?.appAccess?.items;
    const role = edgeAppAccessItems?.find(app => app?.appId?.id === '4')?.roleId?.id;
    const key = `REACT_APP_EDGE_REPORTING_ROLE_${role}`;
    const reportString = myEnv[key];
    const reportArray = reportString?.split(',');
    return reportArray?.includes(String(id));
  };

  return (
    <>
      <SubHeader
        text="EDGE Reporting"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
        popoverTitle="Need help with your Expenses?"
      />
      <Container className="wrap">
        <h1 className="header">{subHeader}</h1>
        <div style={{ width: '100%', marginBottom: '50px' }}>
          <Row className="row" style={{ width: '100%' }}>
            {menuItems
              .filter(i => getsReport(i.id))
              .sort((a, b) => a.text.localeCompare(b.text))
              .map(i => (
                <EdgeMenuItem key={i.text} text={i.text} onPress={() => onPress(i)} disabled={i.disabled} />
              ))}
          </Row>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default EdgeReporting;
